module.exports = __webpack_public_path__ + "img/bkg.fd8e868b.png";